'use client'

import { Avatar, AvatarFallback, AvatarImage } from "@/components/ui/avatar";
import { UserIcon } from "lucide-react";
import { useSession } from "next-auth/react";

export default function AvatarForUser() {
  const session = useSession();

  const user = session?.data?.user || null;

  if (!user) {
    return (
      <Avatar>
        <AvatarFallback>
          <UserIcon className="w-5 h-5 text-muted-foreground" />
        </AvatarFallback>
      </Avatar>
    );
  }

  return (
    <>
      <Avatar>
        <AvatarImage src={user?.image || ""} />
        <AvatarFallback>
          {user?.name
            ? user.name
              .split(" ")
              .map((name) => name[0])
              .join("")
            : user?.email?.[0]?.toUpperCase() || "?"}
        </AvatarFallback>
      </Avatar>
    </>
  );
}